module.exports = __webpack_public_path__ + "img/logo-white-tcs.70a75934.webp";